import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { OnlineItemExternalId } from 'src/online-items/enumerations/OnlineItemAuthorizationTrigger';
import { BalanceInquiryState } from '../../interfaces/states/BalanceInquiryState';

const initialState: BalanceInquiryState = {
  isProcessing: false,
};

class BalanceInquiryReducer extends ImmerReducer<BalanceInquiryState> {
  public setIsProcessing(isProcessing: boolean) {
    this.draftState.isProcessing = isProcessing;
  }

  public SetAuthorizationExternalIdType(type?: OnlineItemExternalId) {
    this.draftState.authorizationExternalIdType = type;
  }
}

export const BalanceInquiryActions = createActionCreators(BalanceInquiryReducer);
export const BalanceInquiryReducerFunction = createReducerFunction(
  BalanceInquiryReducer,
  initialState,
);
